export default __webpack_public_path__ + "static/media/16.0cd2deac.png";